import React from 'react';

// Дані публікацій (можна винести в окремий файл/модуль)
const publicationsData = [
  {
    id: 1,
    title: "Пула, Хорватія",
    date: "21.08.2024",
    description: "На фото - мальовниче узбережжя Адріатичного моря. На скелястому березі можна побачити відпочивальників, що насолоджуються сонячним днем, а в кришталево чистій воді плавають люди.",
    image: "/images/image1.jpg", // Шлях відносно папки public
    alt: "Море і узбережжя"
  },
  {
    id: 2,
    title: "Микуличин, Україна",
    date: "26.06.2024",
    description: "Знімок з серця Карпат демонструє величні гори, оповиті туманом, що надає їм таємничого вигляду. Це ідеальне місце для тих, хто шукає відпочинок від міської метушні та хоче насолодитися красою українських Карпат.",
    image: "/images/image2.jpg",
    alt: "Гори Карпати"
  },
  {
    id: 3,
    title: "Прага, Чехія",
    date: "02.02.2024",
    description: "На фотографії зображена столиця Чехії у вечірній час. На передньому плані видно річку Влтаву з її відображенням вогнів міста. На задньому плані височіє Празький Град, освітлений теплим світлом, що створює контраст з темним небом.",
    image: "/images/image3.jpg",
    alt: "Празький Град"
  },
  {
    id: 4,
    title: "Львів, Україна",
    date: "25.07.2023",
    description: "На фотографії зображений Палац Сосновського у Львові. Його вишукана архітектура з неоготичними та неоренесансними елементами створює атмосферу історичної величі. Балкони, оздоблені арками та декоративними балюстрадами, додають будівлі елегантності, а зелені рослини на балконах підкреслюють її романтичний вигляд. Сонячне світло м'яко освітлює фасад, контрастуючи з тінями, що надає зображенню особливої глибини.",
    image: "/images/palace.jpg",
    alt: "Палац Сосновського"
  }
];

// Компонент сторінки "Публікації"
function Publications() {
  return (
    <section id="publications" className="publications-section">
      <h2>Публікації</h2>
      <div className="publication-list">
        {/* Відображення списку публікацій */}
        {publicationsData.map(pub => (
          <article key={pub.id} className="publication-item">
            <div className="publication-image">
              <img src={process.env.PUBLIC_URL + pub.image} alt={pub.alt} />
            </div>
            <div className="publication-details">
              <h3>{pub.title}</h3>
              <p className="publication-description">{pub.description}</p>
              <p className="publication-date">{pub.date}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

// Експорт компонента за замовчуванням
export default Publications;
